import { Component, OnInit } from '@angular/core';
import { NavigationService } from 'src/app/services/navigation.service';

@Component({
    selector: 'app-locationfacilities',
    templateUrl: './locationfacilities.component.html',
    styleUrls: ['./locationfacilities.component.scss'],
    standalone: false
})
export class LocationfacilitiesComponent implements OnInit {

  constructor(
    private navigateService: NavigationService
  ) { }

  ngOnInit(): void {
  }

  onClickAdd() {
    this.navigateService.gotoLocationAddFacility
``}
}
